import _ from "lodash";

import HNSColors from "../../../../ui library/HNSColors";
import { STYLES } from "../utils/customStyles";

export function getInNetworkColor(inNetwork, receivingClients) {
  if (inNetwork && receivingClients) {
    return [HNSColors.success[700], HNSColors.success[400]];
  }
  if (inNetwork && !receivingClients) {
    return [HNSColors.warning[500], HNSColors.warning[400]];
  }
  if (!inNetwork) {
    return [HNSColors.failure[700], HNSColors.failure[400]];
  }
  return [HNSColors.neutrals[700], HNSColors.neutrals[400]];
}

export function getMenuList(menuOptions) {
  return {
    menuListItems: menuOptions.map((menuOption) => ({
      key: menuOption.key,
      name: menuOption.label,
      props: { sx: STYLES.menuItemStyle },
    })),
    props: {
      PaperProps: { sx: STYLES.menuListStyle },
      anchorOrigin: { vertical: "bottom", horizontal: "left" },
      transformOrigin: { vertical: "top", horizontal: "center" },
    },
  };
}

export function transformProviderDetailData(data) {
  const normalized = convertKeysToCamelCaseDeep(JSON.parse(JSON.stringify(data ?? {})));
  const emails = {};
  const emailOrder = [];
  const contactInfos = {};
  const contactInfoOrder = [];
  const providerTypes = [];

  (normalized?.emails || []).forEach((email) => {
    if (email?.emailType !== null) {
      const typeKey = Number(email.emailType);
      emails[typeKey] = email;
      emailOrder.push(typeKey);
    }
  });

  (normalized?.contactInfos || []).forEach((contactInfo) => {
    if (contactInfo?.contactLabel !== null) {
      const typeKey = Number(contactInfo.contactLabel);
      contactInfos[typeKey] = contactInfo;
      contactInfoOrder.push(typeKey);
    }
  });

  (normalized?.providerTypes || []).forEach((type) => {
    providerTypes.push({ id: type.id, name: type.name, label: type.name });
  });

  return {
    providerTypes,
    parentEntityOption:
      normalized?.entity?.id || normalized?.entity?.pk
        ? {
            id: normalized?.entity?.id ?? normalized?.entity?.pk,
            label:
              normalized?.entity?.name ??
              normalized?.entity?.value ??
              normalized?.entity?.label ??
              "",
          }
        : null,
    entity: normalized?.entity?.id ?? normalized?.entity?.pk ?? normalized?.entity ?? null,
    contractEntity: "",
    ein: "",
    contractStartDate: "",
    contractEndDate: "",
    npi: normalized?.npi ?? "",
    nps: normalized?.nps ?? "",
    homepage: normalized?.homepage,
    address: normalized?.address,
    communicationPreference: normalized?.communicationPreference,
    activeState: normalized?.activeState,
    activeStateName: normalized?.activeStateName ?? null,
    phone: normalized?.phone,
    email: normalized?.email,
    emails,
    emailOrder,
    contactInfos,
    contactInfoOrder,
    notes: normalized?.notes,
    name: normalized?.name,
    inNetwork: normalized?.inNetwork,
    receivingClients: normalized?.receivingClients,
    acceptsFunding: normalized?.acceptsFunding,
    rating: normalized?.rating,
    emrSystem: normalized?.emrSystem ?? "",
    emrUrl: normalized?.emrUrl ?? "",
  };
}

export function mapProviderContractData(data) {
  const normalized = convertKeysToCamelCaseDeep(JSON.parse(JSON.stringify(data ?? {})));
  const hasContractData = [
    normalized?.entity?.name,
    normalized?.contractEntity,
    normalized?.ein,
    normalized?.einNumber,
    normalized?.employerIdentificationNumber,
    normalized?.contractStartDate,
    normalized?.contractEndDate,
    normalized?.startDate,
    normalized?.endDate,
    normalized?.validFrom,
    normalized?.validTo,
    normalized?.termDate,
  ].some((value) => value !== null && value !== undefined && value !== "");

  return {
    contractEntity: hasContractData
      ? (normalized?.entity?.name ??
        normalized?.contractEntity ??
        normalized?.name ??
        normalized?.entityLabel ??
        "")
      : "",
    ein: hasContractData
      ? (normalized?.entity?.einNumber ??
        normalized?.ein ??
        normalized?.einNumber ??
        normalized?.employerIdentificationNumber ??
        "")
      : "",
    contractStartDate: hasContractData
      ? (normalized?.contractStartDate ?? normalized?.startDate ?? normalized?.validFrom ?? "")
      : "",
    contractEndDate: hasContractData
      ? (normalized?.contractEndDate ??
        normalized?.endDate ??
        normalized?.validTo ??
        normalized?.termDate ??
        "")
      : "",
  };
}

export function convertKeysToCamelCaseDeep(input) {
  if (_.isArray(input)) {
    return input.map(convertKeysToCamelCaseDeep);
  }

  if (_.isPlainObject(input)) {
    return _.transform(
      input,
      (result, value, key) => {
        const camelKey = _.camelCase(key);
        result[camelKey] = convertKeysToCamelCaseDeep(value);
      },
      {}
    );
  }

  return input;
}

export const isUnchanged = (initial, updated) => {
  return _.isEqual(initial, updated);
};

export const setNestedValue = (obj, path, value) => {
  _.set(obj, path, value);
  return obj;
};

export const deleteNestedValue = (obj, path) => {
  _.unset(obj, path);
  return obj;
};

export const getDeepDiff = (current, base) =>
  _.transform(current, (result, value, key) => {
    if (!_.isEqual(value, base[key])) {
      result[key] =
        _.isObject(value) && _.isObject(base[key]) ? getDeepDiff(value, base[key]) : value;
    }
  });

export const buildRawAddress = (address) => {
  const secondary =
    address.suiteType && address.suiteNumber ? ` ${address.suiteType} ${address.suiteNumber}` : "";

  return `${address.streetNumber} ${address.route}${secondary}, ${address.city} ${address.state} ${address.postCode}`;
};

export const splitCollectionDiff = (modified, initial, mapUpdate, mapCreate) => {
  const update = [];
  const create = [];
  const remove = [];

  Object.entries(modified).forEach(([key, value]) => {
    if (initial[key]) {
      update.push(mapUpdate(initial[key], value));
    } else {
      create.push(mapCreate(key, value));
    }
  });

  Object.entries(initial).forEach(([key, value]) => {
    if (!modified[key]) {
      remove.push(value.id);
    }
  });

  return { update, create, remove };
};

export const validateProviderNpi = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  return /^\d{10}$/.test(String(value).trim()) ? "" : "NPI must be a 10-digit number";
};
